<template>
  <div class="flex_col">
    <HeaderTop></HeaderTop>
    <div class="main">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from '../../components/header.vue'
import Footer from '../../components/footer.vue';
export default {
    components: {
    HeaderTop,
    Footer
  },
}
</script>

<style>
.main {
  
  flex:1;

}
</style>